
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artist/[id]/[object]",
      function () {
        return require("private-next-pages/artist/[id]/[object].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artist/[id]/[object]"])
      });
    }
  